import { render } from "./WithdrawTX.vue?vue&type=template&id=53e5eae3&scoped=true"
import script from "./WithdrawTX.vue?vue&type=script&lang=js"
export * from "./WithdrawTX.vue?vue&type=script&lang=js"

import "./WithdrawTX.vue?vue&type=style&index=0&id=53e5eae3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e5eae3"]])

export default __exports__